'use client';

import {FooterLink, onFooterLinkClick} from '@ui-kit/src/Footer/Footer.types';
import {footerTestId} from '@ui-kit/src/Footer/footerTestId';
import {useEffect, useState} from 'react';

import styles from './Link.module.scss';

//TODO: Удалить когда закончится кейс что футер показывается в айрейме
export const isShownInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

interface Props {
  link: FooterLink;
  onLinkClick?: (props: onFooterLinkClick) => void;
  index: number;
}

export const Link = ({
  link: {title, ...linkProps},
  onLinkClick,
  index,
}: Props) => {
  const [linksTarget, setLinksTarget] = useState<string | undefined>(
    linkProps.target,
  );

  useEffect(() => {
    const isIframe = isShownInIframe();
    setLinksTarget(isIframe ? '_blank' : linkProps.target);
  }, [linkProps.target]);

  const onClick = () => {
    onLinkClick?.({title, href: linkProps.href, index});
  };

  return (
    <a
      {...linkProps}
      data-testid={footerTestId.link}
      onClick={onClick}
      target={linksTarget}
      className={styles.link}
    >
      {title}
    </a>
  );
};
